import { goToLogin } from '../../auth/authRedirect'
import { useConnection } from '../../state/connection'
import { Icon } from '../../components/Icon'

export function SignInScreen() {
  const online = useConnection((s) => s.online)
  return (
    <main className="sign-in">
      <div className="sign-in-card">
        <img className="app-mark" src="/icons/icon-192.png" alt="" width={72} height={72} />
        <h1 className="chat-wordmark">
          BOSS <span>Chat</span>
        </h1>
        <p>Sign in with your Pub Invest account to see your conversations.</p>
        <button type="button" className="button primary" onClick={() => goToLogin()} disabled={!online}>
          <Icon name="lock" />
          Sign in
        </button>
        {!online ? (
          <p className="notice" role="status">
            You're offline. Connect to the internet to sign in.
          </p>
        ) : null}
      </div>
    </main>
  )
}
